import { EntityFields } from './entity';
import { KeyAndDisplay, TypedKeyAndDisplay } from './key-and-display';
import { ReadRequest, Request } from './request';
import { DataResponse, Response, WriteResponse } from './response';

export const EmailProfileCode = 'EmailProfile';

export enum EmailProfileFields {
  EmailAddress = 'EmailAddress',
  EmailType = 'EmailType',
  Comment = 'Comment',
  EnrollDate = 'EnrollDate',
  ExpiryDate = 'ExpiryDate',
}

export interface EmailProfile {
  [EntityFields.Key]: string;
  [EmailProfileFields.EmailAddress]: string;
  [EmailProfileFields.EmailType]: KeyAndDisplay;
  [EmailProfileFields.Comment]: TypedKeyAndDisplay<number>;
  [EmailProfileFields.EnrollDate]: string;
  [EmailProfileFields.ExpiryDate]: string;
}

export interface EmailProfileReadRequest extends Request {
  EmailProfile: ReadRequest<EmailProfile>;
}

export interface EmailProfileResponse extends Response {
  EmailProfile: DataResponse<EmailProfile>;
}

export interface EmailProfileBulkWriteResponse extends Response {
  [key: `${typeof EmailProfileCode}.${number}`]: WriteResponse<EmailProfile>;
}
